import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import SubcategoryHintBox from './SubcategoryHintBox'

interface Props {
  parentName: string
}

const SubcategoryHint: React.FC<Props> = ({ parentName }) => {
  const { t } = useCustomTranslation()

  return (
    <SubcategoryHintBox>
      <Typography variant={'caption'}>{t('documents.add-subcategory.hint', { parentName })}</Typography>
    </SubcategoryHintBox>
  )
}

export default SubcategoryHint
